<div class="section" [formGroup]="companyContactForm">
  <p class="section__title">Company contacts information ({{ currentContactStep }} of {{ steps.size }})</p>
  <tgx-onboarding-company-contacts-steps
    class="mb-3 mt-3"
    [steps]="steps"
    [isBuyer]="isBuyer"
    [isSeller]="isSeller"
  ></tgx-onboarding-company-contacts-steps>
  <div class="section__item">
    <div class="row">
      <div class="col-5">
        <p class="xen-heading-4 mb-0">{{ userInformationSection[currentContactStep - 1].title }}</p>
        <p class="section__item-subtit">
          {{ userInformationSection[currentContactStep - 1].subtitle }}
        </p>
      </div>
      <div class="col-7">
        <!-- <div class="mb-3 background-color">
          <div>
            <xen-radio
              [label]="'Create a new user with the information provided'"
              [checked]="!isExistingSelectionMode()"
              (click)="handleMemberSelectionMode(true, currentContactStep)"
            ></xen-radio>
          </div>
          <div>
            <xen-radio
              [label]="'No, I want to assign a created user for this step'"
              [checked]="isExistingSelectionMode()"
              (click)="handleMemberSelectionMode(false, currentContactStep)"
            ></xen-radio>
          </div>

          <div class="contact-user-selector mt-2">
            <form class="contact-user-selector__form">
              <xen-select
                [label]="'Select User'"
                [placeholder]="'Select a user'"
                [options]="options"
                [searchable]="false"
                [formControlName]="getControlName('selectedUser')"
                (valueChanged)="onSelectedUserChange(currentStepPrefix, $event)"
              ></xen-select>
            </form>
            <div class="contact-user-selector__link">
              <xen-link
                [size]="'small'"
                [weight]="'regular'"
                [label]="'Edit this contact'"
                [icon]="true"
                [icon_snippet]="'fa-regular fa-pen-to-square'"
                [icon_placement]="'left'"
                [theme]="'blue'"
                [target]="'_self'"
                [underlined]="true"
                [disabled]="true"
              ></xen-link>
            </div>
          </div>
        </div> -->

        @for (step of [currentContactStep]; track step) {
          <div class="row">
            <div class="font-size mb-3">User information</div>
            <div class="col-6">
              <div class="pb-4">
                <xen-input
                  [label]="'First name'"
                  [formControlName]="getControlName('firstName')"
                  [required]="true"
                  [type]="'text'"
                  [placeholder]="'Enter first name'"
                  [size]="'medium'"
                  [validation]="true"
                  [disabled]="isDisabled(getControlName('firstName'))"
                  [validation_status]="getValidationStatus(getControlName('firstName'), true)"
                  [feedback]="
                    companyContactForm.get(getControlName('firstName')).dirty
                      ? $safeNavigationMigration(
                          companyContactForm.get(getControlName('firstName')).errors?.['errorMsg']
                        )
                      : ''
                  "
                ></xen-input>
              </div>
            </div>
            <div class="col-6">
              <div class="pb-4">
                <xen-input
                  [label]="'Last name'"
                  [formControlName]="getControlName('lastName')"
                  [required]="true"
                  [type]="'text'"
                  [placeholder]="'Enter last name'"
                  [size]="'medium'"
                  [validation]="true"
                  [disabled]="isDisabled(getControlName('lastName'))"
                  [validation_status]="getValidationStatus(getControlName('lastName'), true)"
                  [feedback]="
                    companyContactForm.get(getControlName('lastName')).dirty
                      ? $safeNavigationMigration(
                          companyContactForm.get(getControlName('lastName')).errors?.['errorMsg']
                        )
                      : ''
                  "
                ></xen-input>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="pb-4">
                <xen-input
                  [label]="'Job title'"
                  [formControlName]="getControlName('jobTitle')"
                  [required]="true"
                  [type]="'text'"
                  [placeholder]="'Enter job title'"
                  [size]="'medium'"
                  [validation]="true"
                  [validation_status]="getValidationStatus(getControlName('jobTitle'), true)"
                  [feedback]="
                    companyContactForm.get(getControlName('jobTitle')).dirty
                      ? $safeNavigationMigration(
                          companyContactForm.get(getControlName('jobTitle')).errors?.['errorMsg']
                        )
                      : ''
                  "
                ></xen-input>
              </div>
            </div>
            <div class="col-6">
              <div class="pb-4">
                <xen-input
                  [label]="'Email'"
                  [formControlName]="getControlName('email')"
                  [disabled]="isDisabled(getControlName('email'))"
                  [required]="true"
                  [type]="'email'"
                  [placeholder]="'Enter email'"
                  [size]="'medium'"
                  [validation]="true"
                  [validation_status]="getValidationStatus(getControlName('email'), true)"
                  [feedback]="
                    companyContactForm.get(getControlName('email')).dirty
                      ? $safeNavigationMigration(companyContactForm.get(getControlName('email')).errors?.['errorMsg'])
                      : ''
                  "
                ></xen-input>
                @if (getInfoMessageState('showMessageSendRegistration', getControlName('email'))) {
                  <p class="input-info">
                    <i class="fa-regular fa-envelope me-2"></i>We will send a registration email to this contact
                  </p>
                }
                @if (getInfoMessageState('showMessageOwnRegistration', getControlName('email'))) {
                  <p class="input-warn"><i class="fa-regular fa-info-circle me-2"></i>You will be the contact point</p>
                }
                @if (getInfoMessageState('showMessageDuplicatedFormData', getControlName('email'))) {
                  <p class="input-warn">
                    <i class="fa-regular fa-triangle-exclamation me-2"></i>This email is used with differing names.
                    Please verify your first and last names.
                  </p>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="section__item">
    <div class="row">
      <div class="col-5"></div>
      <div class="col-7">
        <div class="font-size mb-3">User permissions</div>
        <tgx-permissions-by-service-form
          [mainRole]="$safeNavigationMigration(loggedUser?.role)"
          [initialPermissions]="effectiveInitialPermissions"
          [canEditRoles]="canEditCurrentStepRoles"
          [isLoading]="isLoading"
          [showPreviousStep]="false"
          (permissionsChanged)="handlePermissionsChanged($event)"
          (invalidForm)="handleInvalidForm($event)"
        ></tgx-permissions-by-service-form>
      </div>
    </div>
  </div>
  <div class="row mb-5">
    <div class="d-flex justify-content-end gap-2">
      @if (!isEditing && currentContactStep > 1) {
        <xen-btn
          class="d-block"
          [type]="'flat'"
          [size]="'large'"
          label="Previous"
          [icon]="true"
          [icon_placement]="'left'"
          [icon_snippet]="'far fa-angle-left'"
          [skin]="'gray'"
          [loading]="isLoading"
          (clicked)="goToPreviousStep()"
        ></xen-btn>
      }
      @if (isEditing) {
        <xen-btn
          class="d-block"
          [type]="'flat'"
          [size]="'large'"
          label="Cancel"
          [icon]="false"
          [skin]="'gray'"
          [loading]="isLoading"
          (clicked)="cancelChanges()"
        ></xen-btn>
      }
      <xen-btn
        class="d-block"
        [type]="'primary'"
        [size]="'large'"
        [label]="buttonName"
        [icon]="true"
        [icon_placement]="'right'"
        [icon_snippet]="'far fa-angle-right'"
        [skin]="'blue'"
        (clicked)="submitCompanyContacts()"
        [disabled]="isButtonDisabled()"
        [loading]="isLoading"
      ></xen-btn>
    </div>
  </div>
</div>
